import { render } from "./top-content.vue?vue&type=template&id=0bd00516&scoped=true"
import script from "./top-content.vue?vue&type=script&lang=js"
export * from "./top-content.vue?vue&type=script&lang=js"

import "./top-content.vue?vue&type=style&index=0&id=0bd00516&scoped=true&lang=less"

import exportComponent from "/home/www/jenkins/jenkins_home/workspace/yizhige_production/yizhige_admin_pro/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0bd00516"]])

export default __exports__